import React from "react";
import GAClassroomAudioReactionDetailsContainer from "../../modules/GAClassroomAudioReactions/containers/GAClassroomAudioReactionDetailsContainer/GAClassroomAudioReactionDetailsContainer";

const GAClassroomAudioReactionDetails = () => {
  return <GAClassroomAudioReactionDetailsContainer />;
};

export default GAClassroomAudioReactionDetails;
